import { Button } from "antd";
import { ProceedChecklist } from "hocs";
import { Map } from "immutable";
import moment from "moment";

export default () => next => action => {
    if (action.type === "FETCHED_STAGES_LIST") {
        ProceedChecklist.registerComponent(Button);
        let checklist = new Map({
            // "MPA": new Map({
            //     mapStateToProps: () => ({}),
            //     evaluator: () =>
            //         new Map({})
            // }),
            // "DPA": new Map({
            //     mapStateToProps: () => ({}),
            //     evaluator: () =>
            //         new Map({})
            // }),
            "1": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "2": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "3": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "4": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "5": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    let caseAssociates = (state.caseDetails.getIn([caseId, "caseAssociates", "data"]) || []).filter(_ => [1,2].includes(Number(_.type))).map(_ => Number(_.company_associate.id));
                    if(caseAssociates) {
                        caseAssociates = caseAssociates.toJS();
                    }
                    const associates = (state.companies.getIn([companyId, "data", "associates"]) || new Map({})).filter(_ => caseAssociates.includes(Number(_.id)));
                    const isCaseEnhacement = state.caseDetails.getIn([caseId, "data", "case_type"]) === 2;

                    const documents = (state.documents.getIn([
                        "company_documents",
                        companyId,
                        "data"
                    ]) || new Map({})).map(_ => _.get("data"));
                    const panCard = documents.filter(_ => _.file && _.document && _.document.id && [7, 12].includes(Number(_.document.id)));
                    const adhaarCard = documents.filter(_ => _.file && _.document && _.document.id && [8, 13].includes(Number(_.document.id)));
                    const gstAttached = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 2);
                    const photographs = documents.filter(_ => _.file && _.document && _.document.id && Number(_.document.id) == 6);
                    const panCardForAllApplicantss = caseAssociates.length && caseAssociates.length <= panCard.size;
                    const adhaarCardForAllApplicantss = caseAssociates.length && caseAssociates.length <= adhaarCard.size;
                    return {
                        all_applicants_with_phone_no: caseAssociates.length && associates.size && !!associates.find(_ => !_.phone),
                        all_applicants_with_email: caseAssociates.length && associates.size && !!associates.find(_ => !_.email),
                        is_pd_submitted: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_pd_submitted"
                        ]),
                        isCaseEnhacement,
                        gstAttached,
                        panCardForAllApplicantss,
                        adhaarCardForAllApplicantss,
                        photographs,
                        is_pd_mandatory: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_pd_mandatory"
                        ]),
                    };
                },
                evaluator: props => {
                    return new Map({
                        all_applicants_with_phone_no: {
                            label: "Updated Phone no for all Applicants",
                            check: !props.all_applicants_with_phone_no
                        },
                        all_applicants_with_email: {
                            label: "Updated Email for all Applicants",
                            check: !props.all_applicants_with_email
                        },is_pd_submitted: {
                            label: "PD Questionnaire Completed",
                            check: props.isCaseEnhacement ? true : props.is_pd_submitted
                        },
                        // photos_of_all_applicants: {
                        //     label: "Photos of All Applicants Attached",
                        //     check: props.photographs && (props.photographs.length || props.photographs.size)
                        // },
                        gstAttached: {
                            label: "Is GST Attached",
                            check: props.gstAttached
                        },
                        panCardForAllApplicantss: {
                            label: "PAN Card",
                            check: props.panCardForAllApplicantss
                        },
                        adhaarCardForAllApplicantss: {
                            label: "Adhaar Card",
                            check: props.adhaarCardForAllApplicantss
                        }
                    }).filter((_, k) => !props.is_pd_mandatory ? k !== "is_pd_submitted" : _ !== null);
                }
            }),
            "20": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const isRequestedExists = (state.documents
                        .getIn(["company_documents", companyId, "data"]) || undefined
                    );
                    const isPendingExists = (state.documents
                        .getIn(["company_documents", companyId, "data"]) || undefined
                    );
                    const isRequestedTick = isRequestedExists ? isRequestedExists.find(_ => _.getIn(["data", "document_status"]) === 1 && _.getIn(["data", "is_active"]) === true )?true:false:true;
                    const isPendingTick = isPendingExists ? isPendingExists.find(_ => _.getIn(["data", "document_status"]) === 3 && _.getIn(["data", "is_active"]) === true )?true:false:true;

                    const isRequested = (state.documents
                        .getIn(["company_documents", companyId, "data"]) || []
                    )
                        .find(_ => _.getIn(["data", "document_status"]) === 1 && _.getIn(["data", "is_active"]) === true );
                    const isPendingApproval = (state.documents
                        .getIn(["company_documents", companyId, "data"]) || []
                    )
                        .find(_ => _.getIn(["data", "document_status"]) === 3 && _.getIn(["data", "is_active"]) === true );
                    const caseAssociates = (state.caseDetails.getIn([caseId, "caseAssociates", "data"]) || []).filter(_ => [1,2].includes(Number(_.type))).map(_ => Number(_.company_associate.id));
                    const associates = (state.companies.getIn([companyId, "data", "associates"]) || new Map({})).filter(_ => caseAssociates.includes(Number(_.type)));
                    const addresses = (state.companies.getIn([companyId, "data", "addresses"]) || new Map({})).filter(_ => !_.associate || caseAssociates.includes(_.associate));
                    const addressesV2 = state.caseDetails.getIn([caseId , "data" , "all_city_and_ownership_type"] , false);
                    const isCaseEnhacement = state.caseDetails.getIn([caseId, "data", "case_type"]) === 2;
                    const distinct_associates_having_address = addresses && (addresses.filter(_ => _.associate).map(_ => _.associate) || new Map({})).toList().toArray();
                    const associatesWithoutAddresses = caseAssociates && distinct_associates_having_address && caseAssociates.filter(_ => !distinct_associates_having_address.includes(_));
                    return {
                        los_to_lms_checklist: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "los_to_lms_checklist"
                        ]),
                        applicants_with_main_borrower: state.caseDetails &&
                        state.caseDetails.getIn([
                            caseId,
                            "caseAssociates",
                            "data"
                        ]) &&
                        state.caseDetails.getIn([
                            caseId,
                            "caseAssociates",
                            "data"
                        ]).find(_ => _.is_main_borrower),
                        operating_address: state.companies &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]) &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]).hasOperatingAddress,
                        registered_address: state.companies &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]) &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]).hasRegisteredAddress,
                        primary_relationship_manager: state.caseDetails.getIn([
                            caseId,
                            "data"
                        ]).hasPrimaryRelationshipManager,
                        cibil_score: state.companies &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]) &&
                        state.companies.getIn([companyId, "data"])
                            .doesAllApplicantsHaveCibil,
                        product: state.caseDetails.getIn([
                            caseId,
                            "data"
                        ]).hasProduct,
                        lending_partner: state.caseDetails.getIn([
                            caseId,
                            "data"
                        ]).hasLendingPartner,
                        ftr_category: state.caseDetails.getIn([
                            caseId,
                            "data"
                        ]).ftr_category,
                        // all_documents_reviewed: isRequested || isPendingApproval ? (
                        //     {
                        //         isRequested,
                        //         isPendingApproval
                        //     }
                        // ) : true,
                        // all_documents_reviewed_check: (isRequestedTick && isPendingTick),
                        all_documents_reviewed_v2: state.caseDetails.getIn([
                            caseId,
                            "data"
                        ]).allDocumentVerified,
                        all_applicants_with_phone_no: associates && associates.find(_ => !_.phone),
                        all_applicants_with_email: associates && associates.find(_ => !_.email),
                        city_and_ownership_status: addressesV2,
                        is_pd_submitted: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_pd_submitted"
                        ]),
                        is_pd_mandatory: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_pd_mandatory"
                        ]),
                        isCaseEnhacement,
                        associatesWithoutAddresses
                    };
                },
                evaluator: props => {
                    return new Map({
                        applicants_with_main_borrower: {
                            label: "Main Borrower",
                            check: props.applicants_with_main_borrower
                        },
                        operating_address: {
                            label: "Operating Address",
                            check: props.operating_address
                        },
                        registered_address: {
                            label: "Registered Address",
                            check: props.registered_address
                        },
                        is_key_bank_account: {
                            label: "Key Bank Account",
                            check: true
                        },
                        cibil_score: {
                            label: "Associate CIBIL",
                            check: !Number.isNaN(props.cibil_score)
                        },
                        primary_relationship_manager: {
                            label: "Primary Relationship Manager",
                            check: true
                        },
                        // all_documents_reviewed: {
                        //     label: "All Documents Reviewed",
                        //     check: !props.all_documents_reviewed_check,
                        //     value: props.all_documents_reviewed
                        // },
                        all_documents_reviewed_v2: {
                            label: "All Documents Reviewed",
                            check: props.all_documents_reviewed_v2,
                            value: props.all_documents_reviewed_v2
                        },
                        product: {
                            label: "Product",
                            check: props.product
                        },
                        lending_partner: {
                            label: "Lending Partner",
                            check: props.lending_partner
                        },
                        all_applicants_with_phone_no: {
                            label: "Updated Phone no for all Applicants",
                            check: !props.all_applicants_with_phone_no
                        },
                        all_applicants_with_email: {
                            label: "Updated Email for all Applicants",
                            check: !props.all_applicants_with_email
                        },
                        city_and_ownership_status: {
                            label: "Updated City and Ownership status in all Addresses",
                            check: props.city_and_ownership_status
                        },
                        all_applicants_with_phone_no: {
                            label: "Applicants Phone No",
                            check: props.los_to_lms_checklist.all_applicants_with_phone_no
                        },
                        // is_seller_key_details_available: {
                        //     label: "Seller Details",
                        //     check: props.los_to_lms_checklist.is_seller_key_details_available
                        // },
                        // is_fee_available: {
                        //     label: "Fee Available",
                        //     check: props.los_to_lms_checklist.is_fee_available
                        // },
                        is_seller_rms_contact_updated: {
                            label: "Seller RMs Contact",
                            check: props.los_to_lms_checklist.is_seller_rms_contact_updated
                        },
                        is_anchor_rms_contact_updated: {
                            label: "Anchor RMs Contact",
                            check: props.los_to_lms_checklist.is_anchor_rms_contact_updated
                        },
                        is_sales_manager_user_contact_updated: {
                            label: "Sales Manager User Contact",
                            check: props.los_to_lms_checklist.is_sales_manager_user_contact_updated
                        },
                        ftr_category: {
                            label: "FTR Category",
                            check: props.ftr_category
                        },
                        // is_pd_submitted: {
                        //     label: "PD Questionnaire Completed",
                        //     check: props.isCaseEnhacement ? true : props.is_pd_submitted
                        // },
                        associatesWithoutAddresses: {
                            label: "All Associates having Addresses",
                            check: !(props.associatesWithoutAddresses && props.associatesWithoutAddresses.length)
                        }
                    }).filter((_, k) => !props.is_pd_mandatory ? k !== "is_pd_submitted" : _ !== null);
                }
            }),
            "6": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "7": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const bank = state.caseDetails.getIn([caseId, "data", "bank", "id"]);
                    const isCaseEnhacement = state.caseDetails.getIn([caseId, "data", "case_type"]) === 2;
                    const userId = state.user.getIn(["data", "id"]);
                    const stageId = state.caseDetails.getIn([caseId, "data", "current_case_task"])[0]?.this_stage;
                    const currentStageCamStatusLogs = state.companyLosProfiles.getIn(['camEngineStatusLogsData', caseId, "status_remark_logs", stageId]);
                    const hasCurrentUserTakenCamStatusAction = currentStageCamStatusLogs && currentStageCamStatusLogs[currentStageCamStatusLogs.length-1]?.userId === userId;
                    return {
                        is_authorized_signatory_exist: state.caseDetails.getIn([caseId, "data", "applicants"]).filter(_ => _.is_authorized_signatory),
                        extra_data : state.caseDetails.getIn([
                            caseId,
                            "data",
                            "extra_data"
                        ]),
                        scheme_sync_with_parent: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "scheme_sync_with_parent"
                        ]),
                        case_type: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "case_type"
                        ]),
                        is_key_account: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_key_account"
                        ]),
                        business_product_type : state.caseDetails.getIn([
                            caseId,
                            "data",
                            "business_product_type"
                        ]),
                        reporting_industry: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "reporting_industry"
                        ]),
                        reporting_anchor: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "reporting_anchor"
                        ]),
                        los_to_lms_checklist: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "los_to_lms_checklist"
                        ]),
                        proposed_limit: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "proposed_limit"
                        ]),
                        isCaseEnhacement,
                        existing_limits: state.companies &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]) &&
                        state.companies.getIn([companyId, "data"])
                            .doesAllExistingLimits,
                        total_sales: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "total_sales"
                        ]),
                        is_pd_submitted: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_pd_submitted"
                        ]),
                        is_cams_breached_case: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "breached_para_status"
                        ]),
                        is_bundled: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_bundled"
                        ]),
                        bundled_limit_percentage: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "bundled_limit_percentage"
                        ]),
                        case_summary_remarks: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "remarks"
                        ]),
                        growth_plan_parameter: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "growth_plan_parameter"
                        ]),
                        scheme_type: state.caseDetails.getIn([caseId, "data", "scheme_type"]),
                        hasCurrentUserTakenCamStatusAction: hasCurrentUserTakenCamStatusAction,
                        is_scheme_present_for_all_supplychains: state.caseDetails &&
                        state.caseDetails.getIn([caseId, "data", "is_scheme_present_for_all_supplychains"]),
                        bank
                    };
                },
                evaluator: props => {
                    return new Map({
                        is_authorized_signatory_exist: {
                            label: "Authorized Signatory",
                            check: props.is_authorized_signatory_exist.length

                        },
                        // retailerRiskConrols: {
                        //     label: "Risk Controls",
                        //     check: props.extra_data && props.extra_data['mpa']
                        // },
                        proposed_limit: {
                            label: "Proposed Limit",
                            check: Number(props.proposed_limit > 0)
                        },
                        total_sales: {
                            label: "Total Sales",
                            check: Number(props.total_sales) > -1
                        },
                        is_pd_submitted: {
                            label: "PD Questionnaire Completed",
                            check: props.isCaseEnhacement ? true : props.is_pd_submitted
                        },
                        cibil_score: {
                            label: "Cibil Score",
                            check: props.los_to_lms_checklist.cibil_score
                        },
                        is_scheme_added: {
                            label: "Scheme Added",
                            check: props.los_to_lms_checklist.is_scheme_added
                        },
                        is_key_account: {
                            label: "Key Bank Account",
                            check: props.is_key_account
                        },
                        business_product_type: {
                            label: "Business Product Type",
                            check: props.business_product_type != 0 && props.business_product_type != null
                        },
                        reporting_industry: {
                            label: "Reporting Industry",
                            check: props.reporting_industry
                        },
                        reporting_anchor: {
                            label: "Reporting Anchor",
                            check: props.reporting_anchor
                        },
                        scheme_sync_with_parent: {
                            label : "Scheme Sync With Parent",
                            check: props.scheme_sync_with_parent,
                        },
                        is_cams_breached_case: {
                            label : "CAMS Breached Case",
                            check: props.is_cams_breached_case === 1 && props.hasCurrentUserTakenCamStatusAction,
                        },
                        is_bundled: {
                            label : "Child sanction limit",
                            check: props.bundled_limit_percentage >0,
                        },
                        case_summary_remarks: {
                            label : "Case Summary Remarks",
                            check: props.case_summary_remarks,
                        },
                        growth_plan_parameter: {
                            label : "Growth Plan Parameter",
                            check: props.growth_plan_parameter,
                        },
                        // supply_chain_exists_in_case: {
                        //     label: "Scheme Selection in Supplychain in Facility/Account Tab",
                        //     check: props.is_scheme_present_for_all_supplychains
                        // }
                    }).filter((value, key) => {
                        if (props.bank === 12 && key === "supply_chain_exists_in_case") {
                            return false;
                          }
                        if(props.scheme_type != 'Factoring' && ['is_authorized_signatory_exist'].includes(key)){
                            return false;
                        }
                        if (props.case_type === 1 && key === "scheme_sync_with_parent") {
                            return false;
                          }
                        if (key === "is_bundled" && !(props.is_bundled && props.scheme_type === "Term Loan")) {
                            return false;
                          }
                        if (value === null) {
                            return false;
                          }
                        return true;
                    })
                }
            }),
            "8": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const userId = state.user.getIn(["data", "id"]);
                    const stageId = state.caseDetails.getIn([caseId, "data", "current_case_task"])[0]?.this_stage;
                    const currentStageCamStatusLogs = state.companyLosProfiles.getIn(['camEngineStatusLogsData', caseId, "status_remark_logs", stageId]);
                    const hasCurrentUserTakenCamStatusAction = currentStageCamStatusLogs && currentStageCamStatusLogs[currentStageCamStatusLogs.length - 1]?.userId === userId
                    return ({
                        comment_added_for_authority_approval: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "comment_added_for_authority_approval"
                        ]),
                        isTlParamsAvailable: state.caseDetails.getIn([caseId, "data", "is_tl_params_available"]),
                        scheme_type: state.caseDetails.getIn([caseId, "data", "scheme_type"]),
                        is_cams_breached_case: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "breached_para_status"
                        ]),
                        hasCurrentUserTakenCamStatusAction: hasCurrentUserTakenCamStatusAction

                    })
                },
                evaluator: props => {
                    let evaluationMap = new Map({
                        comment_added_for_authority_approval: {
                            label: "Authority Approval",
                            check: props.comment_added_for_authority_approval
                        },
                        is_cams_breached_case: {
                            label: "CAMS Breached Case",
                            check: props.is_cams_breached_case === 1 && props.hasCurrentUserTakenCamStatusAction
                        },
                    });
            
                    if (props.scheme_type === "Term Loan") {
                        evaluationMap = evaluationMap.set("isTlParamsAvailable", {
                            label: "TL Parameters Saved",
                            check: props.isTlParamsAvailable
                        });
                    }
            
                    return evaluationMap;
                }
            }),
            "9": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "10": new Map({
                mapStateToProps: (state, caseId, companyId) => ({
                    is_insurance_exempted : state.caseDetails.getIn([
                        caseId,
                        "data",
                        "is_insurance_exempted"
                    ]),
                    is_insurance_consent_provided:state.caseDetails.getIn([
                        caseId,
                        "data",
                        "is_insurance_consent_provided"
                    ]),
                }),
                evaluator: props => {
                    let evaluationMap = new Map({
                        is_insurance_consent_provided: {
                            label: "Is Insurance Consent Provided,",
                            check: props.is_insurance_exempted ? true : props.is_insurance_consent_provided
                        }
                    })
                    return evaluationMap;
                }   
            }),
            // "11": new Map({
            //     mapStateToProps: (state, caseId, companyId) => {
            //         const is_pskit_attached = (state.documents.getIn([
            //             "company_documents",
            //             companyId,
            //             "data"
            //         ]) || new Map({})).map(_ => _.get("data")).toList().toArray().filter(_ => {
            //             return _ &&
            //             _.file &&
            //             _.document &&
            //             _.document.id &&
            //             [18, 19, 20, 56].includes(Number(_.document.id));
            //         });
            //         const bank = state.caseDetails.getIn([caseId, "data", "bank", "code"]);
            //         const caseAssociates = (state.caseDetails.getIn([caseId, "caseAssociates", "data"]) || []).filter(_ => [1,2].includes(Number(_.type))).map(_ => Number(_.company_associate.id));
            //         const associates = (state.companies.getIn([companyId, "data", "associates"]) || new Map({})).filter(_ => caseAssociates.includes(Number(_.type)));
            //         const documents = (state.documents.getIn([
            //             "company_documents",
            //             companyId,
            //             "data"
            //         ]) || new Map({})).map(_ => _.get("data"));
            //         // const isPartnership = (state.companiese.getIn([companyId, "data"]) || {}).constitution == 2;
            //         // const isStampPaper = documents.find(_ => _.document && _.document.id && _.document.id === null);
            //         const applicationFormWithSignedPhoto = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 18);
            //         const bankSanctionLetter = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 19);
            //         const loanAgreementPaper = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 20);
            //         const letterOfAuthorizationJana = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 39);
            //         const signatureVerificationMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 28);
            //         const utilityBillMuthoot = documents.find(_ => _.file && _.document && _.document.id && [3,9].includes(Number(_.document.id)));
            //         const drawDownRequestMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 21);
            //         const securityChecksMuthoot = documents.filter(_ => _.file && _.document && _.document.id && Number(_.document.id) === 34);
            //         const partnershipLetterMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 39);
            //         const NachMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 35);
            //         const is_processing_fee_applicable = state.caseDetails.getIn([caseId, "data", "prepaid_processing_fee"]);

            //         return {
            //             is_seller_key_details_available: state.caseDetails.getIn([
            //                 caseId,
            //                 "data",
            //                 "is_seller_key_details_available"
            //             ]),
            //             is_scheme_added: state.caseDetails.getIn([
            //                 caseId,
            //                 "data",
            //                 "is_scheme_added"
            //             ]),
            //             is_scheme_created_on_lms: state.caseDetails.getIn([
            //                 caseId,
            //                 "data",
            //                 "is_scheme_created_on_lms"
            //             ]),
            //             is_fee_available: state.caseDetails.getIn([
            //                 caseId,
            //                 "data",
            //                 "is_fee_available"
            //             ]),
            //             is_processing_fee_added: is_processing_fee_applicable ? state.caseDetails.getIn([
            //                 caseId,
            //                 "data",
            //                 "is_processing_fee_paid"
            //             ]) : true,
            //             is_pskit_attached: !!(is_pskit_attached && is_pskit_attached.length),
            //             all_applicants_with_phone_no: associates && associates.find(_ => !_.phone || !_.first_name || !_.email),
            //             cibil_score: state.companies &&
            //             state.companies.getIn([
            //                 companyId,
            //                 "data"
            //             ]) &&
            //             state.companies.getIn([companyId, "data"])
            //                 .doesAllApplicantsHaveCibil,
            //             applicationFormWithSignedPhoto: !!applicationFormWithSignedPhoto,
            //             bankSanctionLetter: !!bankSanctionLetter,
            //             loanAgreementPaper: !!loanAgreementPaper,
            //             letterOfAuthorizationJana: !!letterOfAuthorizationJana,
            //             signatureVerificationMuthoot: !!signatureVerificationMuthoot,
            //             utilityBillMuthoot: !!utilityBillMuthoot,
            //             drawDownRequestMuthoot: !!drawDownRequestMuthoot,
            //             securityChecksMuthoot: !!(securityChecksMuthoot && securityChecksMuthoot.length === 3),
            //             partnershipLetterMuthoot: !!partnershipLetterMuthoot,
            //             NachMuthoot: !!NachMuthoot,
            //             bank: bank
            //         };
            //     },
            //     evaluator: (props) =>
            //         new Map({
            //             is_seller_key_details_available: {
            //                 label: "Seller Details",
            //                 check: props.is_seller_key_details_available,
            //                 bank: props.bank
            //             },
            //             is_scheme_added: {
            //                 label: "Seller Scheme Added",
            //                 check: props.is_scheme_added,
            //                 bank: props.bank
            //             },
            //             is_fee_available: {
            //                 label: "Fee Program Added",
            //                 check: props.is_fee_available,
            //                 bank: props.bank
            //             },
            //             is_scheme_created_on_lms: {
            //                 label: "Is Scheme Created On LMS",
            //                 check: props.is_scheme_created_on_lms,
            //                 bank: props.bank
            //             },
            //             is_processing_fee_added: {
            //                 label: "Processing Fee Added",
            //                 check: props.is_processing_fee_added,
            //                 bank: props.bank
            //             },
            //             is_pskit_attached: {
            //                 label: "Is PS-Kit Attached",
            //                 check: props.is_pskit_attached,
            //                 bank: props.bank
            //             },
            //             all_applicants_with_phone_no: {
            //                 label: "Updated Applicants Details",
            //                 check: !props.all_applicants_with_phone_no,
            //                 bank: props.bank
            //             },
            //             cibil_score: {
            //                 label: "Associate CIBIL",
            //                 check: !Number.isNaN(props.cibil_score),
            //                 bank: props.bank
            //             },
            //             // applicationFormWithSignedPhoto: {
            //             //     label: "Application Form with Signed Photo",
            //             //     check: props.applicationFormWithSignedPhoto,
            //             //     bank: props.bank
            //             // },
            //             // bankSanctionLetter: {
            //             //     label: "Bank Sanction Letter",
            //             //     check: props.bankSanctionLetter,
            //             //     bank: props.bank
            //             // },
            //             // loanAgreementPaper: {
            //             //     label: "Loan Agreement Paper",
            //             //     check: props.loanAgreementPaper,
            //             //     bank: props.bank
            //             // },
            //             // letterOfAuthorizationJana: {
            //             //     label: "Letter of Authorization",
            //             //     check: props.letterOfAuthorizationJana,
            //             //     bank: "JSFB"
            //             // },
            //             // signatureVerificationMuthoot: {
            //             //     label: "Signature Verification",
            //             //     check: props.signatureVerificationMuthoot,
            //             //     bank: "MF"
            //             // },
            //             // utilityBillMuthoot: {
            //             //     label: "Utility Bill",
            //             //     check: props.utilityBillMuthoot,
            //             //     bank: "MF"
            //             // },
            //             // drawDownRequestMuthoot: {
            //             //     label: "Draw Down Request",
            //             //     check: props.drawDownRequestMuthoot,
            //             //     bank: "MF"
            //             // },
            //             // securityChecksMuthoot: {
            //             //     label: "Associate CIBIL",
            //             //     check:props.securityChecksMuthoot,
            //             //     bank: "MF"
            //             // },
            //             // partnershipLetterMuthoot: {
            //             //     label: "Partnership Authorization Letter",
            //             //     check: props.partnershipLetterMuthoot,
            //             //     bank: "MF"
            //             // },
            //             // NachMuthoot: {
            //             //     label: "NACH",
            //             //     check: props.NachMuthoot,
            //             //     bank: "MF"
            //             // }
            //         }).filter(_ => _.bank === props.bank)
            // })

            "11": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const banks = state.caseDetails.getIn([caseId, "caseBankAccounts", "data"]);
                    const documents = (state.documents.getIn([
                        "company_documents",
                        companyId,
                        "data"
                    ]) || new Map({})).map(_ => _.get("data"));
                    const isPartnership = (state.companies.getIn([companyId, "data"]) || {}).constitution == 2;
                    const securityChecks = documents.filter(_ => _.file && _.document && _.document.id && Number(_.document.id) === 34);
                    const partnershipLetter = documents.find(_ => _.file && _.document && _.document.id && _.document.id === 39);
                    const Nach = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 35);
                    const applicationFormWithSignedPhoto = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 18);
                    const bankSanctionLetter = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 19);
                    const signatureVerification = documents.find(_ => _.file && _.document && _.document.id && _.document.id === 28);
                    const vernacularDeclaration = documents.find(_ => _.file && _.document && _.document.id && _.document.id === 33);
                    const isPskitAttached = documents.filter(_ => _.file && _.document && _.document.id && [18, 19, 20, 56].includes(_.document.id));
                    const is_processing_fee_applicable = state.caseDetails.getIn([caseId, "data", "prepaid_processing_fee"]);
                    const is_bnpl_case = state.caseDetails.getIn([caseId, "data", "is_bnpl_case"]);
                    const is_term_loan_created_on_lms = state.caseDetails.getIn([caseId, "data", "is_term_loan_created_on_lms"]);
                    const bank= state.caseDetails.getIn([Number(caseId), "data", "bank", "code"]);
                    const shopPhotos = state.caseDetails.getIn([Number(caseId), "data",  'is_self_served_journey'] ,false) || ([78,79,80].every(_ => documents.find( __ => __.file && __.document && __.document.id && __.document.id == _)) || (bank == "KSF|HHPL" && moment(state.caseDetails.getIn([Number(caseId), "data", "create_date"])) < Date.now())) ;
                    const kycValue = state.caseDetails.getIn([caseId, "data", "kyc_status"]);
                    const deferralTagged = state.caseDetails.getIn([caseId, "data", "deferral_tagged"]);
                    const schemeType = state.caseDetails.getIn([caseId, "data", "scheme_type"]);
                    const isKeyAccount = state.caseDetails.getIn([caseId, "data", "is_key_account"]);
                    return {
                        is_seller_key_details_available: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_seller_key_details_available"
                        ]),
                        is_scheme_added: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_scheme_added"
                        ]),
                        is_scheme_created_on_lms: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_scheme_created_on_lms"
                        ]),
                        is_fee_available: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_fee_available"
                        ]),
                        is_processing_fee_added: is_processing_fee_applicable ? state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_processing_fee_paid"
                        ]) : true,
                        pskit_re_signed: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "pskit_re_signed"
                        ]), 
                        is_ps_kit_signed: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_ps_kit_signed"
                        ]), 
                        banks,
                        isPartnership,
                        securityChecks: !!securityChecks,
                        partnershipLetter: !!partnershipLetter,
                        Nach: !!Nach,
                        applicationFormWithSignedPhoto: !!applicationFormWithSignedPhoto,
                        bankSanctionLetter: !!bankSanctionLetter,
                        signatureVerification: !!signatureVerification,
                        shopPhotos: !!shopPhotos,
                        kycValue: !!kycValue,
                        vernacularDeclaration: !!vernacularDeclaration,
                        isPskitAttached: !!(isPskitAttached && isPskitAttached.size),
                        is_bnpl_case,
                        is_term_loan_created_on_lms,
                        bank,
                        deferralTagged,
                        schemeType,
                        isKeyAccount,
                    };
                },
                evaluator: (props) =>{
                   return  new Map({
                        is_seller_key_details_available: {
                            label: "Seller Details",
                            check: props.is_seller_key_details_available,
                            bank: props.bank
                        },
                        is_scheme_added: {
                            label: "Seller Scheme Added",
                            check: props.is_scheme_added,
                            bank: props.bank
                        },
                        is_fee_available: {
                            label: "Fee Program Added",
                            check: props.is_fee_available,
                            bank: props.bank
                        },
                        // is_scheme_created_on_lms: {
                        //     label: "Is Scheme Created On LMS",
                        //     check: props.is_scheme_created_on_lms,
                        //     bank: props.bank
                        // },
                        is_processing_fee_added: {
                            label: "Processing Fee Added",
                            check: props.is_processing_fee_added,
                            bank: props.bank
                        },
                        is_pskit_attached: {
                            label: "Is PS-Kit Attached",
                            check: props.isPskitAttached,
                            bank: props.bank
                        },
                        // applicationFormWithSignedPhoto: {
                        //     label: "Application Form with Signed Photo",
                        //     check: props.applicationFormWithSignedPhoto,
                        // },
                        // bankSanctionLetter: {
                        //     label: "Bank Sanction Letter",
                        //     check: props.bankSanctionLetter,
                        // },
                        // signatureVerification: {
                        //     label: "Signature Verification",
                        //     check: props.signatureVerification,
                        // },
                        securityChecks: {
                            label: "3 Security Cheques",
                            check:props.securityChecks,
                            bank: props.bank
                        },
                        // shopPhotos: {
                        //     label: "Shop Photos",
                        //     check:props.shopPhotos,
                        //     bank: props.bank
                        // },
                        kycValue: {
                            label: "KYC Value",
                            check:props.kycValue,
                            bank: props.bank
                        },
                        pskit_re_signed: {
                            label: "PS-Kit Re Signed",
                            check:props.pskit_re_signed,
                            bank: props.bank
                        },
                        is_ps_kit_signed: {
                            label: "PS-Kit Signed",
                            check:props.is_ps_kit_signed,
                            bank: props.bank
                        },                        
                        // vernacularDeclaration: {
                        //     label: "Vernacular Declaration",
                        //     check:props.vernacularDeclaration,
                        // },
                        // partnershipLetter: {
                        //     label: "Partnership Authorization Letter",
                        //     check: props.isPartnership ? props.partnershipLetter : true
                        // },
                        // Nach: {
                        //     label: "NACH",
                        //     check: props.Nach
                        // },
                        termLoan: {
                            label: "Term Loan Created",
                            check: props.is_term_loan_created_on_lms,
                            bank: props.bank
                        },
                        deferralTagged: {
                            label: "Is Deferred",
                            check: props.deferralTagged === true || props.deferralTagged === false,
                            bank: props.bank
                        },
                        isKeyAccount: {
                            label: "Is Key Account",
                            check: props.isKeyAccount,
                            bank: props.bank
                        },
                    }).filter((_, k) =>{
                        if(props.schemeType !== 'Term Loan' && k === "isKeyAccount"){
                            return false;
                        }
                        return(!props.isPartnership ? k !== "partnershipLetter" : _ !== null) && _.bank === props.bank;})
                    .filter((_, key) => !(key == "pskit_re_signed" && _.check === ""))
                    }

            }),
            "12": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "13": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "14": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "17": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "18": new Map({
                mapStateToProps: (state, caseId, companyId) => ({
                    operating_address: (state.companies.getIn([
                        companyId,
                        "data"
                    ]) || {}).hasOperatingAddress,
                    registered_address: (state.companies.getIn([
                        companyId,
                        "data"
                    ]) || {}).hasRegisteredAddress,
                }),
                evaluator: props =>
                    new Map({
                        operating_address: {
                            label: "Operating Address",
                            check: props.operating_address
                        },
                        registered_address: {
                            label: "Registered Address",
                            check: props.registered_address
                        },
                    })
            }),
            "42": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "56": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const kycValue = state.caseDetails.getIn([caseId, "data", "kyc_status"]);

                    return {
                        kycValue: !!kycValue,
                    }
                },
                evaluator: props => {
                    let evaluationMap = new Map({
                        kycValue: {
                            label: "KYC Value",
                            check: props.kycValue,
                            bank: props.bank
                        },
                    })
                    return evaluationMap;
                }
            }),
            "35": new Map({
                mapStateToProps: () => ({}),
                evaluator: () =>
                    new Map({})
            }),
            "54": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    return {
                        is_case_approved_by_authority: state.caseDetails.getIn([caseId, "data", "is_case_approved_by_authority"]),
                    }
                },
                evaluator: (props) =>
                    new Map({
                        is_case_approved_by_authority: {
                            label: "Is Authority Approved",
                            check: props.is_case_approved_by_authority
                        },
                    })
            }),
            "57": new Map({
                mapStateToProps: () => ({}),
                evaluator: (props) =>
                    new Map({})
            }),
            "19": new Map({
                mapStateToProps: (state, caseId, companyId) => {
                    const is_pskit_attached = (state.documents.getIn([
                        "company_documents",
                        companyId,
                        "data"
                    ]) || new Map({})).map(_ => _.get("data")).toList().toArray().filter(_ => {
                        return _ &&
                        _.file &&
                        _.document && 
                        _.document.id && 
                        [18, 19, 20, 56].includes(Number(_.document.id));
                    });
                    const bank = state.caseDetails.getIn([caseId, "data", "bank", "code"]);
                    const caseAssociates = (state.caseDetails.getIn([caseId, "caseAssociates", "data"]) || []).filter(_ => [1,2].includes(Number(_.type))).map(_ => Number(_.company_associate.id));
                    const associates = (state.companies.getIn([companyId, "data", "associates"]) || new Map({})).filter(_ => caseAssociates.includes(Number(_.type)));
                    const documents = (state.documents.getIn([
                        "company_documents",
                        companyId,
                        "data"
                    ]) || new Map({})).map(_ => _.get("data"));
                    const isPartnership = (state.companies.getIn([companyId, "data"]) || {}).constitution == 2;
                    // const isStampPaper = documents.find(_ => _.document && _.document.id && _.document.id === null);
                    const applicationFormWithSignedPhoto = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 18);
                    const bankSanctionLetter = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 19);
                    const loanAgreementPaper = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 20);
                    const letterOfAuthorizationJana = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 39);
                    const signatureVerificationMuthoot = documents.find(_ => _.file && _.document && _.document.id && _.document.id === 28);
                    const utilityBillMuthoot = documents.find(_ => _.file && _.document && _.document.id && [3,9].includes(Number(_.document.id)));
                    const drawDownRequestMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 21);
                    const securityChecksMuthoot = documents.filter(_ => _.file && _.document && _.document.id && Number(_.document.id) === 34);
                    const partnershipLetterMuthoot = documents.find(_ => _.file && _.document && _.document.id && _.document.id === 39);
                    const NachMuthoot = documents.find(_ => _.file && _.document && _.document.id && Number(_.document.id) === 35);
                    const is_processing_fee_applicable = state.caseDetails.getIn([caseId, "data", "prepaid_processing_fee"]);
                    return {
                        is_seller_key_details_available: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_seller_key_details_available"
                        ]),
                        is_scheme_added: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_scheme_added"
                        ]),
                        is_scheme_created_on_lms: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_scheme_created_on_lms"
                        ]),
                        is_fee_available: state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_fee_available"
                        ]),
                        is_processing_fee_added: is_processing_fee_applicable ? state.caseDetails.getIn([
                            caseId,
                            "data",
                            "is_processing_fee_paid"
                        ]) : true,
                        is_pskit_attached: !!(is_pskit_attached && is_pskit_attached.length),
                        all_applicants_with_phone_no: associates && associates.find(_ => !_.phone || !_.first_name || !_.email),
                        cibil_score: state.companies &&
                        state.companies.getIn([
                            companyId,
                            "data"
                        ]) &&
                        state.companies.getIn([companyId, "data"])
                            .doesAllApplicantsHaveCibil,
                        applicationFormWithSignedPhoto: !!applicationFormWithSignedPhoto,
                        bankSanctionLetter: !!bankSanctionLetter,
                        loanAgreementPaper: !!loanAgreementPaper,
                        letterOfAuthorizationJana: !!letterOfAuthorizationJana,
                        signatureVerificationMuthoot: !!signatureVerificationMuthoot,
                        utilityBillMuthoot: !!utilityBillMuthoot,
                        drawDownRequestMuthoot: !!drawDownRequestMuthoot,
                        securityChecksMuthoot: !!securityChecksMuthoot,
                        partnershipLetterMuthoot: !!partnershipLetterMuthoot,
                        NachMuthoot: !!NachMuthoot,
                        bank: bank,
                        isPartnership
                    };
                },
                evaluator: (props) =>
                    new Map({
                        is_seller_key_details_available: {
                            label: "Seller Details",
                            check: props.is_seller_key_details_available,
                            bank: props.bank
                        },
                        is_scheme_added: {
                            label: "Seller Scheme Added",
                            check: props.is_scheme_added,
                            bank: props.bank
                        },
                        is_fee_available: {
                            label: "Fee Program Added",
                            check: props.is_fee_available,
                            bank: props.bank
                        },
                        // is_scheme_created_on_lms: {
                        //     label: "Is Scheme Created On LMS",
                        //     check: props.is_scheme_created_on_lms,
                        //     bank: props.bank
                        // },
                        is_processing_fee_added: {
                            label: "Processing Fee Added",
                            check: props.is_processing_fee_added,
                            bank: props.bank
                        },
                        is_pskit_attached: {
                            label: "Is PS-Kit Attached",
                            check: props.is_pskit_attached,
                            bank: props.bank
                        },
                        all_applicants_with_phone_no: {
                            label: "Updated Applicants Details",
                            check: !props.all_applicants_with_phone_no,
                            bank: props.bank
                        },
                        cibil_score: {
                            label: "Associate CIBIL",
                            check: !Number.isNaN(props.cibil_score),
                            bank: props.bank
                        },

                        // applicationFormWithSignedPhoto: {
                        //     label: "Application Form with Signed Photo",
                        //     check: props.applicationFormWithSignedPhoto,
                        //     bank: props.bank
                        // },
                        // bankSanctionLetter: {
                        //     label: "Bank Sanction Letter",
                        //     check: props.bankSanctionLetter,
                        //     bank: props.bank
                        // },
                        loanAgreementPaper: {
                            label: "Loan Agreement Paper",
                            check: props.loanAgreementPaper,
                            bank: props.bank
                        },
                        letterOfAuthorizationJana: {
                            label: "Letter of Authorization",
                            check: props.letterOfAuthorizationJana,
                            bank: "JSFB"
                        },
                        // signatureVerificationMuthoot: {
                        //     label: "Signature Verification",
                        //     check: props.signatureVerificationMuthoot,
                        //     bank: "MF"
                        // },
                        utilityBillMuthoot: {
                            label: "Utility Bill",
                            check: props.utilityBillMuthoot,
                            bank: "MF"
                        },
                        drawDownRequestMuthoot: {
                            label: "Draw Down Request",
                            check: props.drawDownRequestMuthoot,
                            bank: "MF"
                        },
                        securityChecksMuthoot: {
                            label: "3 Security Cheques",
                            check:props.securityChecksMuthoot,
                            bank: "MF"
                        },
                        // partnershipLetterMuthoot: {
                        //     label: "Partnership Authorization Letter",
                        //     check: props.isPartnership ? props.partnershipLetterMuthoot : true,
                        //     bank: "MF"
                        // },
                        // NachMuthoot: {
                        //     label: "NACH",
                        //     check: props.NachMuthoot,
                        //     bank: "MF"
                        // }
                    }).filter(_ => _.bank === props.bank)
            }),
        });

        ProceedChecklist.registerChecklist(checklist);
        next(action);
    }
    next(action);
};